'use client';

import { useMemo } from 'react';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { LDOptions } from 'launchdarkly-js-client-sdk';
import { useUser } from '~/app/_ui/shared/UserProvider/UserProvider';
import { toLaunchDarklyContext } from './user';
import { LDFlagSet } from './flags';
import env from '~/env.public';

export default function LaunchDarklyProvider({
  children,
  bootstrapFlags,
}: {
  children: React.ReactNode;
  bootstrapFlags: LDFlagSet;
}) {
  const user = useUser();
  const userContext = useMemo(() => toLaunchDarklyContext(user), [user]);

  const options: LDOptions = useMemo(
    () => ({
      streaming: true,
      bootstrap: bootstrapFlags,
    }),
    [bootstrapFlags],
  );

  return (
    <LDProvider
      clientSideID={env.LAUNCHDARKLY_CLIENT_ID ?? ''}
      user={userContext}
      options={options}
    >
      {children}
    </LDProvider>
  );
}
